// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__eHScM","footer":"ModalCreateQualiphyProcedure_footer__2pnzE","additionData":"ModalCreateQualiphyProcedure_additionData__3-lRN"};